<template>
  <div>
    <v-chip
        small
        class="ma-1"
        v-if="showMoreItems.index !== item.id || !showMoreItems.status"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ item[secondaryField][0] | truncate(50) }}</span>
        </template>
        <span class="text-style">
        {{ item[secondaryField][0] }}
      </span>
      </v-tooltip>
    </v-chip>
    <v-chip
        v-for="(data, i) in item[secondaryField]"
        small
        :key="i"
        class="ma-1"
        v-if="showMoreItems.status && showMoreItems.index === item.id"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ data | truncate(50) }}</span>
        </template>
        <span class="text-style">
        {{ data }}
      </span>
      </v-tooltip>
    </v-chip>
    <v-chip
        x-small
        class="ma-1"
        v-if="item[secondaryField].length > 1"
        @click="expandLocation(item.id)"
    >
      ({{
        showMoreItems.status && showMoreItems.index === item.id
            ? '-'
            : '+'
      }}
      {{ item[secondaryField].length - 1 }}
      {{ $t('general.titles.others') }})
    </v-chip>
  </div>
</template>

<script>
  export default {
    name: 'ShowMoreComponent',

    props: {
      item: {
        type: Object,
        required: true,
      },
      secondaryField: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      showMoreItems: {
        status: true,
        index: 0,
      },
    }),

    filters: {
      truncate(text, length, clamp) {
        clamp = clamp || '...'
        let node = document.createElement('div')
        node.innerHTML = text
        let content = node.textContent
        return content.length > length
          ? content.slice(0, length) + clamp
          : content
      },
    },

    methods: {
      expandLocation(id) {
        this.showMoreItems.status =
          this.showMoreItems.index !== id
            ? this.showMoreItems.status
            : !this.showMoreItems.status
        this.showMoreItems.index = id
      },
    },
  }
</script>

<style scoped>
.text-style {
  font-size: 12px;
  color: #f5f5f5
}
</style>
